import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { routes } from 'flow/types/routes';
import { QueueKey } from 'flow/types/EntityKeys';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';

interface Props {
    queueKey: QueueKey;
}

const ButtonQueueSettings = ({ queueKey }: Props) => {
    const { i18next } = useAppContext();
    const history = useHistory();
    return (
        <IconButton
            tooltipLabel={i18next.t('settings')}
            onClick={() =>
                history.push(
                    generatePath(routes['pbx.queues.entityKey.settings'], {
                        entityKey: queueKey,
                    }),
                )
            }
        >
            <Icon iconKey="setting_menu" />
        </IconButton>
    );
};

export default ButtonQueueSettings;
